import type React from 'react';
import { useCallback, useState, useContext } from 'react';
import { markerSelection } from '@/app/components/search/components/SearchPageContainer/MapContainer/utils.ts';
import { CardsContext } from '../../SearchPageContainer/ListContainer/CardsGrid/CardsContext';

export const handleShowHotelMarkerInMap = (hotelId?: number) => {
  const marker = document.querySelector(`[data-id="${hotelId}"]`);
  if (marker) {
    markerSelection(hotelId, true);
    return;
  }

  const observer = new MutationObserver((_, obs) => {
    const found = document.querySelector(`[data-id="${hotelId}"]`);
    if (found) {
      markerSelection(hotelId, true);
      obs.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
  setTimeout(() => observer.disconnect(), 10000);
};

export const useViewOnMap = (handleShowMap: () => void, onMapOpenedFromCard?: () => void) => {
  const { isWaiting } = useContext(CardsContext);
  const [highlightedHotelId, setHighlightedHotelId] = useState<number | null>(null);

  const handleShowHotelInMapList = useCallback((hotelId: number) => {
    setHighlightedHotelId(hotelId);

    // auto-clear after 1.5s (animation runs for ~0.8s)
    setTimeout(() => setHighlightedHotelId((current) => (current === hotelId ? null : current)), 1500);
  }, []);

  const handleViewMapClick = (e: React.MouseEvent<HTMLButtonElement>, hotelId: number) => {
    e.preventDefault();
    e.stopPropagation();
    if (!isWaiting) {
      onMapOpenedFromCard?.();
      handleShowMap();
      handleShowHotelInMapList(hotelId);
      handleShowHotelMarkerInMap(hotelId);
    }
  };

  return { highlightedHotelId, handleViewMapClick };
};
